import { render, staticRenderFns } from "./VotersOnDistribution.vue?vue&type=template&id=29daf3b6"
import script from "./VotersOnDistribution.vue?vue&type=script&lang=js"
export * from "./VotersOnDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports